if (document.querySelector('.intro-banner.product-list-banner, .intro-banner.pep-banner')) {
  import(/* webpackChunkName: "PEP-banners", webpackPrefetch: true */'./../../../custom-components/PEP-v2/modules/PEP-banners/index').then(function () {
    console.log('PEP-banners Loaded');
  }).catch(function (error) {
    console.log('An error occurred while loading the component for PEP-banners');
    console.log(error);
  });
}